import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useStaggeredAnimation } from '@/features/client-onboarding/hooks/use-staggered-animation';
import { useOnboardingNavigationActions } from '@/features/client-onboarding/stores/onboarding-navigation-store';

import { selectClient } from '@/model';

export function useOverviewSlide(stepCount: number) {
  const client = useSelector(selectClient);
  const { reset } = useOnboardingNavigationActions();

  const { visibleIndices, visibleLineIndices } = useStaggeredAnimation(stepCount, {
    baseDelay: 150,
    cardDuration: 350,
    lineDuration: 350,
  });

  useEffect(() => {
    reset();
  }, [reset]);

  return {
    clientFirstName: client.clientFirstName,
    visibleIndices,
    visibleLineIndices,
  };
}
